module.exports = __webpack_public_path__ + "static/media/abtimg1.e3d0cac8.png";